<template>
    <div>
        <b-container fluid class="mt--7">
            <list-items
                v-if="isList"
                :title="title"
                :items="assets"
                :crm="crm"
                :crm-setting-value="crmSettingValue"
                ref="table"
                :officers="officers"
                :roles="roles"
                :types="types"
            >
                <import-form
                    subject="Assets"
                    v-model="importModal"
                    @cancel="hideModal()"
                    :fields="assetFields"
                    :upload-record="uploadAssetRecord"
                    settings-key-name="assetUploadKey"
                ></import-form>

                <page-actions
                    :buttons-actions="buttonActions"
                    control-class="float-right"
                    control-size="sm"
                />
            </list-items>

            <view-item
                :id="id"
                :crm="crm"
                @success="alertSuccess"
                @error="showError"
                :officers="officers"
                :types="types"
                v-else
            ></view-item>
        </b-container>
    </div>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import ImportForm from '@/components/ImportForm.vue'

import PageActions from '@/components/PageActions.vue'

import popupMixins from '@/mixins/popupMixins'
import showItemHelper from '@/mixins/showItemHelper'
import permissionsMixins from '@/mixins/permissionsMixins'
import importMixins from '@/mixins/importMixins'

const assetFields = [
    { name: 'name', required: true, type: 'text' },
    { name: 'model_no', required: true, type: 'text' },
    { name: 'serial_no', required: false, type: 'text' },
    { name: 'asset_type_name', required: true, type: 'text' },
    { name: 'customer_code', required: true, type: 'text' },
    { name: 'manufacturer_name', required: true, type: 'text' },
    { name: 'vendor', required: true, type: 'text' },
    { name: 'last_service_date', required: false, type: 'text' },
    { name: 'next_service_date', required: false, type: 'text' },
    { name: 'warranty_expiry_date', required: false, type: 'text' },
    { name: 'contract_expiry_date', required: false, type: 'text' },
    { name: 'frequency', required: true, type: 'text' },
    { name: 'description', required: false, type: 'text' },
    { name: 'service_week_day', required: false, type: 'text' },
    { name: 'service_time_of_day', required: false, type: 'text' },
    { name: 'default_engineer_id', required: false, type: 'text' },
]

export default {
    name: 'assets',
    components: {
        ListItems,
        ViewItem,
        ImportForm,
        PageActions,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins, importMixins],
    data: () => {
        return {
            importModal: false,
            componentName: 'Asset',
            ListItems,
            assetFields,
            item: null,
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },
        roles() {
            return this.$store.state.roles.items
        },
        title() {
            const { crm } = this
            return crm ? 'CRM Tasks' : 'Assets Management'
        },
        assets() {
            const _assets = this.$store.state.assets.assets
            console.log('assets-----', _assets)
            return _assets
        },
        types() {
            const { type_id } = this.crmSettingValue
            const { crm } = this
            const _types = this.$store.state.assets.types || []
            console.log('asset types')
            console.log('types-------', _types)
            console.log('crm-------', crm)
            const filteredTypes = _types.filter(x =>
                crm ? x.id == type_id : x.id != type_id
            )
            console.log('filteredTypes-------', filteredTypes)
            return filteredTypes
        },

        officers() {
            return this.$store.getters['users/sorted_officers']
        },     
    
        vendors() {
            return this.$store.state.assets.vendors
        },
        newRoute() {
            return this.$route.path + '/' + this.id + '/usage'
        },

        freqSettingKey() {
            return this.$store.state.company.settingKeys.assetFrequencyKey
        },
        buttonActions() {
            const actions = []
            const { crm } = this

            if (this.crm) {
                actions.push({
                    action: () => this.generateCRMReport(),
                    icon: 'download',
                    variant: 'light',
                    tooltip: 'CRM  Report',
                })
            }

            if (this.hasPermissionCreate) {
                actions.push({
                    action: () => this.createNewAsset(),
                    icon: 'plus-circle',
                    variant: 'light',
                    tooltip: crm ? 'Create New CRM' : 'Create New Asset',
                })
            }

            if (this.hasPermissionCreate && !this.crm) {
                actions.push({
                    action: () => this.importOrders(),
                    icon: 'upload',
                    variant: 'light',
                    tooltip: 'Import Assets',
                })
            }
            if (this.hasPermissionView && !this.crm) {
                actions.push({
                    action: () => this.exportOrders(),
                    icon: 'download',
                    variant: 'light',
                    tooltip: 'Export Assets',
                })
            }
            return actions
        },
        crmSettingValue() {
            return this.$store.getters['company/crmSettingValue']
        },
        crmsettingsKey() {
            return this.$store.state.company.settingKeys.crmsettingsKey
        },
        crm() {
            console.log("this.$route.name.slice(0, 3)",this.$route )
            return this.$route.name.slice(0, 3) === 'crm'
        },
    },

    watch: {
        crm: function () {
            this.$nextTick(() => {
                this.$refs.table.pureSearch(true)
            })
        },
    },

    created() {
        console.log(' this.freqSettingKey', this.freqSettingKey)
        this.$store.dispatch('company/fetchConfiguration', this.freqSettingKey)
        this.$store.dispatch('roles/fetchAll')
        this.$store.dispatch('assets/listTypes')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('locations/fetchWarehouses')
    },
    mounted() {
        console.log('asset  route', this.$route)
        console.log('user', this.user)

        this.$store.dispatch('company/fetchConfiguration', this.crmsettingsKey)

        this.$store.dispatch('users/fetchAll')
    },

    methods: {
        alertSuccess(action, assetName) {
            this.genericToast(
                this.componentName,
                `${action.charAt(0).toUpperCase() + action.slice(1)}d`,
                'success',
                `${assetName} has been successfully ${action}d`
            )
        },

        showError(error, name) {
            const interror = 'Internal Server Error'
            if (interror == error.message) {
                this.genericToast(
                    this.componentName,
                    'Duplicate',
                    'danger',
                    `"${name}" already exists as an ${
                        this.componentName
                    }. Please create a new ${this.componentName.toLowerCase()}`
                )
            }
        },

        getQueryString() {
            const searchItems = this.$refs.table.getSearchQuery()
            console.log('searchItems', searchItems)
            return `&query=${btoa(JSON.stringify(searchItems))}`
        },
        getReportExtension(rpt_type) {
            if (rpt_type.indexOf('pdf') >= 0 || rpt_type.indexOf('report') >= 0)
                return `pdf`
            else return `xlsx`
        },
        async generateCRMReport() {
            try {
                this.report_loading = true
                const rpt_type = 'HO2apDD'
                const queryString = this.getQueryString(rpt_type)
                console.log('queryString', queryString)
                const ext = this.getReportExtension(rpt_type)
                const fileName = `crm-report.${ext}`

                console.log('query string', { rpt_type, queryString, fileName })
                await this.$store.dispatch('js_report/downloadDocument', {
                    rpt_type,
                    queryString,
                    fileName,
                })
            } catch (err) {
                console.log('err', err)
                this.doToast(
                    'Error!',
                    'Error Detected. Please consult your System Administrator',
                    'danger'
                )
            } finally {
                this.report_loading = false
            }
        },

        createNewAsset() {
            this.$router.push(`${this.$route.path}/0`)
        },
        importOrders() {
            this.importModal = true
        },
        exportOrders() {
            this.$refs.table.showDetailsDialog()
        },
        async uploadAssetRecord(
            dataRecord,
            statusRecord,
            check,
            statuses,
            setLoading
        ) {
            try {
                let {
                    name,
                    asset_type_name,
                    serial_no,
                    model_no,
                    manufacturer_name,
                    customer_code,
                    description,
                    vendor: vendor_name,
                    warranty_expiry_date,
                    last_service_date,
                    next_service_date,
                    frequency,
                    service_week_day,
                    service_time_of_day,
                    contract_expiry_date,
                    default_engineer_id,
                } = dataRecord

                statusRecord.status = statuses.CHECKING

                console.log('check', check)
                if (check != 1) throw new Error('Invalid Entry!')

                const vendor_id = this.getCustomEntityId(
                    vendor_name,
                    this.vendors,
                    'name',
                    'Vendor'
                )
                const manufacturer_id = this.getCustomEntityId(
                    manufacturer_name,
                    this.vendors,
                    'name',
                    'Vendor'
                )

                const type_id = this.getCustomEntityId(
                    asset_type_name,
                    this.types,
                    'name',
                    'asset_type'
                )

                //customer ID
                const customerfetchparam = {
                    query: '',
                    page: 1,
                    filters: { code: customer_code },
                }
                await this.$store.dispatch(
                    'customers/fetch',
                    customerfetchparam
                )
                const items = this.$store.state.customers.items

                console.log('Customers', { items })

                if (items.length == 0)
                    throw new Error("Customer Code Doesn't exist")

                const { id: customer_id, location_section_id } = items[0]
                if (!location_section_id) throw new Error('Location Not Found')

                default_engineer_id = default_engineer_id || null
                contract_expiry_date = contract_expiry_date || null
                service_time_of_day = service_time_of_day || null
                service_week_day = service_week_day || null
                next_service_date = next_service_date || null
                const notes = null
                const manual_url = null
                const service_plan_url = null
                const image_url = null
                const order_template_id = null

                const payload = {
                    name,
                    type_id,
                    serial_no,
                    model_no,
                    manufacturer_id,
                    customer_id,
                    vendor_id,
                    warranty_expiry_date,
                    last_service_date,
                    next_service_date,
                    location_section_id,
                    frequency,
                    description,
                    service_week_day,
                    service_time_of_day,
                    contract_expiry_date,
                    default_engineer_id,
                    notes,
                    manual_url,
                    service_plan_url,
                    image_url,
                    order_template_id,
                }

                console.log('Parameters', payload)

                const res = await this.$store.dispatch('assets/create', {
                    payload,
                })

                console.log('response:', res)

                // set status to complete if the upload was successful
                statusRecord.status = statuses.COMPLETE
            } catch (err) {
                console.error('err', err)
                statusRecord.error_list =
                    typeof err.message == 'string'
                        ? [['error', [err.message]]]
                        : Object.entries(err.message)
                statusRecord.status = statuses.ERROR
            } finally {
                setLoading(false)
            }
        },
    },
}
</script>
<style></style>
